export default "__VITE_ASSET__CUvgWHx9__"